isResponseError404orRange500